'use strict';

var TreeGridValidatorService = function TreeGridValidatorService() {
  function validate(field, value) {
    if (field.ignoreValidation) {
      return true;
    }
    if (value === undefined) {
      return {
        message: 'Missing value!',
        result: false
      };
    }
    if (field.type === 'DATETIME') {
      if (field.inputFilter.isValid && !field.inputFilter.isValid()) {
        return {
          message: 'Invalid date',
          result: false
        };
      }
    } else if (field.type === 'BOOLEAN') {
      if (value !== 'true' && value !== 'false') {
        return {
          message: 'The value must be "true" or "false"',
          result: false
        };
      }
    } else if (field.type === 'INTEGER') {
      if (!/^\d+$/.test(value)) {
        return {
          message: 'The value must be an integer',
          result: false
        };
      }
    } else if (field.type === 'FLOAT') {
      if (!/^\d+(\.\d*)?$/.test(value)) {
        return {
          message: 'The value must be a float',
          result: false
        };
      }
    } else if (field.type === 'STRING') {
      if (value.trim() === '') {
        return {
          message: 'The value must not be empty',
          result: false
        };
      }
    } else if (field.type === 'DTD') {
      if (!/^[-]?\d+$/.test(value)) {
        return {
          message: 'The value must be an integer',
          result: false
        };
      }
    }
    return true;
  }
  return {
    validate: validate
  };
};
TreeGridValidatorService.$inject = [];
module.exports = TreeGridValidatorService;